(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-collector-comments"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));

    const initializeReview = (root) => {
      if (!root || root.dataset.acReviewEnhanced === 'true') return;
      root.dataset.acReviewEnhanced = 'true';

      const grid = root.querySelector('[data-ac-review-grid]');
      const toggles = Array.from(root.querySelectorAll('[data-ac-review-toggle]'));
      const cards = Array.from(root.querySelectorAll('[data-ac-mobile-card]'));
      if (!grid || toggles.length === 0) return;

      const setExpanded = (expanded) => {
        grid.classList.toggle('is-expanded', expanded);
        toggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      };

      const setTransitioning = (transitioning) => {
        root.dataset.acReviewTransitioning = transitioning ? 'true' : 'false';
        toggles.forEach((toggle) => {
          toggle.disabled = transitioning;
        });
      };

      const visibleCards = () => cards.filter((card) => getComputedStyle(card).display !== 'none');

      const collapsibleCards = () => {
        const selector = window.matchMedia('(max-width: 699px)').matches
          ? '.ac-collector-comments__mobile-card--mobile-extra'
          : '.ac-collector-comments__mobile-card--desktop-extra';

        return cards.filter((card) => card.matches(selector));
      };

      const capturePositions = (elements) => new Map(
        elements.map((element) => [element, element.getBoundingClientRect()])
      );

      const animateLayout = (elements, previousPositions, duration = 420) => {
        return elements.flatMap((element) => {
          const previous = previousPositions.get(element);
          if (!previous) return [];

          const current = element.getBoundingClientRect();
          const deltaX = previous.left - current.left;
          const deltaY = previous.top - current.top;

          if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) return [];

          return [element.animate(
            [
              { transform: `translate(${deltaX}px, ${deltaY}px)` },
              { transform: 'translate(0, 0)' }
            ],
            {
              duration,
              easing: 'cubic-bezier(.22, 1, .36, 1)',
              fill: 'both'
            }
          )];
        });
      };

      const settleAnimations = async (animations, cancelAfter = true) => {
        await Promise.allSettled(animations.map((animation) => animation.finished));
        if (cancelAfter) animations.forEach((animation) => animation.cancel());
      };

      const reveal = async (toggle) => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const initiallyVisible = visibleCards();

        if (reducedMotion) {
          setExpanded(true);
          return;
        }

        setTransitioning(true);
        const previousPositions = capturePositions([...initiallyVisible, toggle]);
        setExpanded(true);
        await nextFrame();

        const nowVisible = visibleCards();
        const layoutAnimations = animateLayout([...initiallyVisible, toggle], previousPositions);
        const revealAnimations = nowVisible
          .filter((card) => !previousPositions.has(card))
          .map((card, index) => card.animate(
            [
              { opacity: 0, transform: 'translateY(10px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            {
              duration: 420,
              delay: Math.min(index * 34, 136),
              easing: 'cubic-bezier(.22, 1, .36, 1)',
              fill: 'backwards'
            }
          ));

        await settleAnimations([...layoutAnimations, ...revealAnimations]);
        setTransitioning(false);
      };

      const preserveViewportAnchor = (toggle, previousTop) => {
        const currentTop = toggle.getBoundingClientRect().top;
        const scrollDelta = currentTop - previousTop;
        if (Math.abs(scrollDelta) < 1) return;
        window.scrollBy({ top: scrollDelta, behavior: 'auto' });
      };

      const collapse = async (toggle) => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const anchorTop = toggle.getBoundingClientRect().top;

        if (reducedMotion) {
          setExpanded(false);
          await nextFrame();
          preserveViewportAnchor(toggle, anchorTop);
          toggle.focus({ preventScroll: true });
          return;
        }

        setTransitioning(true);
        const extras = collapsibleCards().filter((card) => getComputedStyle(card).display !== 'none');
        const fadeAnimations = extras.map((card, index) => card.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(6px)' }
          ],
          {
            duration: 170,
            delay: Math.min(index * 18, 72),
            easing: 'cubic-bezier(.4, 0, 1, 1)',
            fill: 'forwards'
          }
        ));

        await settleAnimations(fadeAnimations, false);

        const remainingCards = cards.filter((card) => !extras.includes(card));
        const previousPositions = capturePositions([...remainingCards, toggle]);
        setExpanded(false);
        fadeAnimations.forEach((animation) => animation.cancel());
        await nextFrame();
        preserveViewportAnchor(toggle, anchorTop);

        const layoutAnimations = animateLayout([...visibleCards(), toggle], previousPositions, 360);
        await settleAnimations(layoutAnimations);
        setTransitioning(false);
        toggle.focus({ preventScroll: true });
      };

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', async () => {
          if (root.dataset.acReviewTransitioning === 'true') return;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';

          if (!expanded) {
            await reveal(toggle);
            return;
          }

          await collapse(toggle);
        });
      });

      setExpanded(false);
    };

    const initializeAllReviews = (scope = document) => {
      scope.querySelectorAll('[data-ac-review-root]').forEach(initializeReview);
    };

    initializeAllReviews();
    document.addEventListener('shopify:section:load', (event) => initializeAllReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
